export const FETCH_QR_CODE = 'FETCH_QR_CODE';
export const FETCH_QR_CODE_FAILED = 'FETCH_QR_CODE_FAILED';
export const FETCH_QR_CODE_SUCCEED = 'FETCH_QR_CODE_SUCCEED';

export const WAIT_FOR_AUTH = 'WAIT_FOR_AUTH';
export const WAIT_FOR_AUTH_FAILED = 'WAIT_FOR_AUTH_FAILED';
export const WAIT_FOR_AUTH_SUCCEED = 'WAIT_FOR_AUTH_SUCCEED';

export const REGISTER = 'REGISTER';
export const REGISTER_SUCCEED = 'REGISTER_SUCCEED';
export const REGISTER_FAILED = 'REGISTER_FAILED';

export const LOGIN_NORMAL = 'LOGIN_NORMAL';
export const LOGIN_NORMAL_SUCCEED = 'LOGIN_NORMAL_SUCCEED';
export const LOGIN_NORMAL_FAILED = 'LOGIN_NORMAL_FAILED';

export const VERIFY_EMAIL = 'VERIFY_EMAIL';
export const VERIFY_EMAIL_SUCCEED = 'VERIFY_EMAIL_SUCCEED';
export const VERIFY_EMAIL_FAILED = 'VERIFY_EMAIL_FAILED';

export const LOGOUT = 'LOGOUT';
export const LOGOUT_SUCCEED = 'LOGOUT_SUCCEED';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const LOGIN_QR_1 = 'LOGIN_QR_1';
export const LOGIN_QR_1_SUCCEED = 'LOGIN_QR_1_SUCCEED';
export const LOGIN_QR_1_FAILED = 'LOGIN_QR_1_FAILED';

export const LOGIN_QR_2 = 'LOGIN_QR_2';
export const LOGIN_QR_2_SUCCEED = 'LOGIN_QR_2_SUCCEED';
export const LOGIN_QR_2_FAILED = 'LOGIN_QR_2_FAILED';

export const LOGIN_QR_3 = 'LOGIN_QR_3';
export const LOGIN_QR_3_SUCCEED = 'LOGIN_QR_3_SUCCEED';
export const LOGIN_QR_3_FAILED = 'LOGIN_QR_3_FAILED';

export const LOGIN_QR_SUCCEED = 'LOGIN_QR_SUCCEED';

export const VERIFY_WITHDRAWAL = 'VERIFY_WITHDRAWAL';
export const VERIFY_WITHDRAWAL_SUCCEED = 'VERIFY_WITHDRAWAL_SUCCEED';
export const VERIFY_WITHDRAWAL_FAILED = 'VERIFY_WITHDRAWAL_FAILED';

export const GET_USER_LOGIN_HISTORY = 'GET_USER_LOGIN_HISTORY';
export const GET_USER_LOGIN_HISTORY_SUCCEED = 'GET_USER_LOGIN_HISTORY_SUCCEED';
export const GET_USER_LOGIN_HISTORY_FAIL = 'GET_USER_LOGIN_HISTORY_FAIL';
